/* Aura 2027 product page view (new version only).
   Builds the hero gallery, glass controls, buy sheet/panel, set card and bento from the product data in #pm-au-data.
   The real variant controls, the add-to-cart form and the set sheet keep doing the work: this view only drives them. */
(function () {
  'use strict';

  /* ---- add to cart feedback: the brand mark works while the item is added, then the button says Added and the cart bumps ---- */
  (function () {
    var SEL = '.pms-bar-case, .au-add, .pms-cart2';
    var cur = null, tNone = null, tOk = null, sent = false, obs = null;
    var realFetch = window.fetch;
    function stopWatch() { if (obs) { obs.disconnect(); obs = null; } }
    function watch() {
      stopWatch();
      var cnt = document.querySelector('#CartCount'), dr = document.querySelector('.ctdrawer'), c0 = cnt ? cnt.textContent : '';
      if (!window.MutationObserver) return;
      obs = new MutationObserver(function () {
        if (!cur) return;
        if ((cnt && cnt.textContent !== c0) || (dr && dr.classList.contains('active'))) { sent = true; clearTimeout(tNone); stopWatch(); ok(); }
      });
      if (cnt) obs.observe(cnt, { childList: true, characterData: true, subtree: true });
      if (dr) obs.observe(dr, { attributes: true, attributeFilter: ['class'] });
    }
    function clear() {
      clearTimeout(tNone); clearTimeout(tOk); stopWatch();
      if (cur) { cur.classList.remove('is-busy', 'is-ok'); cur.removeAttribute('aria-busy'); }
      cur = null; sent = false;
    }
    function bump() {
      [].forEach.call(document.querySelectorAll('.au-glass[data-act="cart"], .header-cart'), function (e) {
        e.classList.remove('pm-bump'); void e.offsetWidth; e.classList.add('pm-bump');
      });
    }
    function ok() {
      if (!cur) return;
      var b = cur;
      b.classList.remove('is-busy'); b.classList.add('is-ok'); b.removeAttribute('aria-busy');
      try { if (navigator.vibrate) navigator.vibrate(12); } catch (e) { e = 0; }
      bump();
      try {
        realFetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var n = document.querySelector('#CartCount');
          if (n && c && typeof c.item_count === 'number') n.textContent = c.item_count;
        }).catch(function () { /* ignore */ });
      } catch (e) { e = 0; }
      tOk = setTimeout(function () { b.classList.remove('is-ok'); if (cur === b) { cur = null; sent = false; } }, 1200);
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest(SEL);
      if (!b || b.disabled || b.classList.contains('is-busy')) return;
      clear();
      cur = b; sent = false;
      b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true');
      watch();
      tNone = setTimeout(function () { if (!sent) clear(); }, 9000);
    });
    if (realFetch) {
      window.fetch = function (u) {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        var p = realFetch.apply(this, arguments);
        if (cur && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
          sent = true; clearTimeout(tNone);
          p.then(function (r) { if (r && r.ok) { stopWatch(); ok(); } else clear(); }, function () { clear(); });
        }
        return p;
      };
    }
  })();

  var raw = document.getElementById('pm-au-data');
  if (!raw) return;
  var D;
  try { D = JSON.parse(raw.textContent); } catch (e) { return; }
  if (!D.images || !D.images.length || !D.variants || !D.variants.length) return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: D.cur }).format(c / 100); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function ic(name) {
    if (name === 'mark') return '<svg class="pmk" viewBox="0 0 632 505" aria-hidden="true" focusable="false"><path class="pmk-b" d="M35 212h170v258H35z"/><path class="pmk-d" d="M35 35h217l122.6 118.4A80 80 0 0 1 261.4 266.6z"/><path class="pmk-c" d="M402 470V132.5a97.5 97.5 0 0 1 195 0V470z"/></svg>';
    var p = {
      menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
      share: '<path d="M12 15V4M8 8l4-4 4 4"/><path d="M5 12v7h14v-7"/>',
      cart: '<path d="M3 4h2.5l2.2 10.5a1.5 1.5 0 001.5 1.2h7.6a1.5 1.5 0 001.5-1.1L20 8H6.4"/><circle cx="10" cy="20" r="1.3"/><circle cx="17" cy="20" r="1.3"/>',
      check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
      left: '<path d="M15 5l-7 7 7 7"/>', right: '<path d="M9 5l7 7-7 7"/>',
      truck: '<rect x="1" y="6" width="14" height="11" rx="1.5"/><path d="M15 10h4l3 3v4h-7v-7z"/><circle cx="6" cy="19" r="2"/><circle cx="17.5" cy="19" r="2"/>',
      back: '<path d="M3 12a9 9 0 109-9"/><path d="M3 4v5h5"/>',
      tag: '<path d="M20.6 13.4L11 3.8A2 2 0 009.6 3.2L3 3v6.6a2 2 0 00.6 1.4l9.6 9.6a2 2 0 002.8 0l4.6-4.6a2 2 0 000-2.6z"/><circle cx="7.5" cy="7.5" r="1.2"/>'
    }[name] || '';
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>';
  }

  function init() {
    var host = document.querySelector('.product-single');
    var form = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
    var vs = document.querySelector('variant-selects');
    if (!host || !form || !host.parentNode) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;

    var names = D.options.map(function (n) { return String(n).toLowerCase(); });
    var cIdx = -1, mIdx = -1, i;
    for (i = 0; i < names.length; i++) { if (cIdx < 0 && /colo/.test(names[i])) cIdx = i; if (mIdx < 0 && /model|device|compat|phone/.test(names[i])) mIdx = i; }
    var otherIdx = [];
    for (i = 0; i < names.length; i++) { if (i !== cIdx && i !== mIdx && D.variants.length > 1) otherIdx.push(i); }
    var byImg = {};
    D.images.forEach(function (im, k) { byImg[im.id] = k; });
    var moreById = {};
    (D.more || []).forEach(function (m) { moreById[m.id] = m; });

    var pending = null, pendAt = 0;
    function curV() {
      if (pending) {
        if (String(idInput.value) === String(pending.id) || Date.now() - pendAt > 2500) pending = null;
        else return pending;
      }
      for (var k = 0; k < D.variants.length; k++) { if (String(D.variants[k].id) === String(idInput.value)) return D.variants[k]; }
      return D.variants[0];
    }
    /* the variant a tap will land on: the new value, keeping every other choice the shopper already made */
    function pickVariant(idx, val) {
      var cur = curV(), best = null, bs = -1;
      D.variants.forEach(function (v) {
        if (v.o[idx] !== val) return;
        var sc = v.a ? 0.5 : 0;
        for (var q = 0; q < v.o.length; q++) { if (q !== idx && v.o[q] === cur.o[q]) sc += 1; }
        if (sc > bs) { bs = sc; best = v; }
      });
      return best;
    }
    function values(idx) {
      var seen = {}, out = [];
      D.variants.forEach(function (v) {
        var val = v.o[idx];
        if (!seen[val]) { seen[val] = { v: val, img: -1, avail: false }; out.push(seen[val]); }
        if (v.a) seen[val].avail = true;
        if (seen[val].img < 0 && byImg[v.i] != null) seen[val].img = byImg[v.i];
      });
      return out;
    }

    /* ---------- markup ---------- */
    var cv0 = curV();
    /* the photo that is on screen first (the chosen variant's) is the one loaded at top priority */
    var firstK = (cv0 && cv0.i != null && byImg[cv0.i] != null) ? byImg[cv0.i] : 0;
    var imgsHtml = D.images.map(function (im, k) {
      var ss = esc(String(im.s).replace('width=1000', 'width=600')) + ' 600w, ' + esc(String(im.s).replace('width=1000', 'width=800')) + ' 800w, ' + esc(im.s) + ' 1000w';
      /* photos beside the first one start without a source (they are given one on touch or when the page is idle) */
      var srcAttr = k === firstK ? 'src="' + esc(im.s) + '" srcset="' + ss + '"' : 'data-hs="' + esc(im.s) + '" data-hss="' + ss + '"';
      return '<img class="au-img" ' + srcAttr + ' alt="' + esc(im.a) + '" style="background:url(' + esc(im.t) + ') center/cover" sizes="(min-width: 900px) 50vw, 100vw" width="1000" height="1000" ' + (k === firstK ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"') + ' decoding="async">';
    }).join('');
    var thumbsHtml = D.images.map(function (im, k) {
      return '<button type="button" class="au-th' + (k === 0 ? ' is-on' : '') + '" data-go="' + k + '" aria-label="Photo ' + (k + 1) + '"><img src="' + esc(im.t) + '" alt="" width="72" height="72" loading="lazy" decoding="async"></button>';
    }).join('');
    var dotsHtml = D.images.slice(0, 8).map(function (im, k) { return '<i class="au-dot' + (k === 0 ? ' is-on' : '') + '"></i>'; }).join('');

    var oldH1 = document.querySelector('h1.product-single__title'); if (oldH1) oldH1.setAttribute('role', 'presentation'); // one heading level 1 on the rendered page
    var root = document.createElement('section');
    root.className = 'au';
    root.setAttribute('aria-label', 'Product');
    root.innerHTML =
      '<div class="au-grid">' +
      '<div class="au-hero">' +
        '<div class="au-glow" aria-hidden="true"></div>' +
        '<div class="au-track" tabindex="0" aria-label="Product photos">' + imgsHtml + '</div>' +
        '<div class="au-top">' +
          '<button type="button" class="au-glass" data-act="menu" aria-label="Menu">' + ic('mark') + '</button>' +
          '<span class="au-top-r"><button type="button" class="au-glass" data-act="share" aria-label="Share">' + ic('share') + '</button>' +
          '<button type="button" class="au-glass" data-act="cart" aria-label="Cart">' + ic('cart') + '<b class="au-badge" hidden></b></button></span>' +
        '</div>' +
        '<button type="button" class="au-fit au-fit-hero" data-act="model"><span class="au-fit-i">' + ic('check') + '</span><span class="au-fit-t"></span></button>' +
        '<div class="au-dots" aria-hidden="true">' + dotsHtml + '</div>' +
        '<div class="au-count" aria-hidden="true"><span>1</span> / ' + D.images.length + '</div>' +
        '<button type="button" class="au-glass au-arrow au-prev" data-act="prev" aria-label="Previous photo">' + ic('left') + '</button>' +
        '<button type="button" class="au-glass au-arrow au-next" data-act="next" aria-label="Next photo">' + ic('right') + '</button>' +
        '<div class="au-thumbs">' + thumbsHtml + '</div>' +
      '</div>' +
      '<div class="au-sheet">' +
        '<h1 class="au-title">' + esc(D.title) + '</h1>' +
        '<div class="au-price"><b class="au-now"></b><s class="au-was"></s><span class="au-save"></span></div>' +
        '<div class="au-opts"></div>' +
        '<div class="au-cta">' +
          '<button type="button" class="au-btn au-add" data-act="add">Add to cart</button>' +
          '<button type="button" class="au-btn au-buy" data-act="buy">Buy now</button>' +
          '<div class="au-paynote">Apple Pay &middot; Google Pay &middot; Shop Pay &middot; Secure checkout</div>' +
        '</div>' +
        '<button type="button" class="au-set" data-act="set" hidden></button>' +
        '<div class="au-slot-pair"></div>' +
        '<div class="au-cards">' +
          '<div class="au-card"><span class="au-card-i">' + ic('truck') + '</span><b>Ships out 1-3 days</b><small>Free shipping over ' + (D.freeFmt || money(D.free)) + '</small></div>' +
          '<div class="au-card"><span class="au-card-i">' + ic('back') + '</span><b>30-day returns</b><small>Does not fit? Send it back</small></div>' +
        '</div>' +
      '</div>' +
      '</div>';
    host.parentNode.insertBefore(root, host);
    var ssrHero = document.querySelector('.au-ssr');
    if (ssrHero) {
      root.className += ' au-from-ssr';
      /* the photo already on screen becomes the gallery photo itself (same element), so it is painted once and not drawn again */
      var sImg = ssrHero.querySelector('img');
      if (sImg) {
        var base = function (u) { return String(u).split('?')[0]; };
        var mine = [].filter.call(root.querySelectorAll('.au-img'), function (x) { return base(x.getAttribute('src')) === base(sImg.getAttribute('src')); })[0];
        if (mine) {
          sImg.className = 'au-img';
          sImg.setAttribute('alt', mine.getAttribute('alt') || '');
          sImg.setAttribute('style', mine.getAttribute('style') || '');
          sImg.setAttribute('loading', 'eager');
          mine.parentNode.replaceChild(sImg, mine);
        }
      }
      if (ssrHero.parentNode) ssrHero.parentNode.removeChild(ssrHero);
    }
    document.documentElement.classList.add('pm-aura');
    document.documentElement.classList.remove('pm-aura-pending');
    host.setAttribute('aria-hidden', 'true');

    /* ---------- bento grid below the buy area (tablet and desktop) ---------- */
    var bentoEl = document.createElement('div');
    bentoEl.className = 'au-bento';
    var benefits = [];
    [].forEach.call(document.querySelectorAll('.ph-desc-benefit'), function (b) {
      var t = b.querySelector('b, strong, [class*="title"], h3, h4');
      var txt = (t ? t.textContent : (b.innerText || '').split('\n').filter(Boolean)[0] || '').replace(/\s+/g, ' ').trim();
      if (txt && benefits.indexOf(txt) < 0 && benefits.length < 5) benefits.push(txt);
    });
    bentoEl.innerHTML =
      '<div class="au-bhead"><h2 class="au-bh">Everything for your <span class="au-bm">phone</span></h2><span class="au-bs">Matched to <b class="au-bc"></b>. Swap any piece.</span></div>' +
      '<div class="au-bgrid' + (benefits.length ? '' : ' no-ben') + '">' +
        '<div class="au-b au-b-set" hidden><div class="au-b-top"><b>Make it a set</b><small>One checkout, matched to your case</small></div><div class="au-b-ths"></div><div class="au-b-meta"><span class="au-b-t"></span><span class="au-b-p"></span></div><button type="button" class="au-b-btn" data-act="set">Customise your set</button></div>' +
        '<div class="au-b au-b-fit"><span class="au-b-eyebrow">Fit</span><h3 class="au-b-h"></h3><p>Pick your phone once and we show what fits it, in the colour you chose.</p><div class="au-b-chips"><span class="au-b-chip"></span><button type="button" class="au-b-chip is-btn" data-act="model">Change</button></div></div>' +
        (benefits.length ? '<div class="au-b au-b-ben"><span class="au-b-eyebrow">Protection</span><h3 class="au-b-h">Built to protect</h3><ul>' + benefits.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>' : '') +
        '<div class="au-b au-b-del"><span class="au-b-eyebrow">Delivery</span><h3 class="au-b-h">Ships out 1-3 days</h3><p>Tracked, and free over ' + (D.freeFmt || money(D.free)) + '.</p></div>' +
        '<div class="au-b au-b-ret"><span class="au-b-eyebrow">Returns</span><h3 class="au-b-h">30 days</h3><p>Does not fit? Send it back.</p></div>' +
        '<button type="button" class="au-b au-b-rev" data-act="reviews"><span class="au-b-eyebrow">Reviews</span><h3 class="au-b-h">What customers say</h3><span class="au-b-link">Read reviews &rsaquo;</span></button>' +
      '</div>';
    root.appendChild(bentoEl);

    var track = root.querySelector('.au-track');
    var optsEl = root.querySelector('.au-opts');

    /* the photos beside the first one wait until the shopper touches the gallery or the page has settled, so they do not compete with it */
    var held = [];
    [].forEach.call(track.querySelectorAll('.au-img'), function (im, k) {
      if (im.getAttribute('data-hs') && !im.getAttribute('src')) held.push(im);
    });
    function wake() {
      held.splice(0).forEach(function (im) { im.setAttribute('srcset', im.getAttribute('data-hss')); im.setAttribute('src', im.getAttribute('data-hs')); });
    }
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, wake, { passive: true, once: true }); });
    if (document.readyState === 'complete') setTimeout(wake, 2500); else window.addEventListener('load', function () { setTimeout(wake, 2500); });

    /* ---------- option rows ---------- */
    var colourVals = cIdx > -1 ? values(cIdx) : [];
    var modelVals = mIdx > -1 ? values(mIdx) : [];
    var html = '';
    if (colourVals.length > 1) {
      html += '<div class="au-row au-colours"><div class="au-label">' + esc(D.options[cIdx]) + ': <b class="au-cname"></b></div><div class="au-pills" data-opt="' + cIdx + '">';
      colourVals.forEach(function (c, k) {
        var im = c.img > -1 ? D.images[c.img].t : D.images[0].t;
        html += '<button type="button" class="au-sw' + (k > 4 ? ' is-x' : '') + (c.avail ? '' : ' is-out') + '" data-v="' + esc(c.v) + '" aria-label="' + esc(c.v) + '" aria-pressed="false"><img src="' + esc(im) + '" alt="" width="40" height="40" loading="lazy"></button>';
      });
      if (colourVals.length > 5) html += '<button type="button" class="au-more" data-act="more">+' + (colourVals.length - 5) + '</button>';
      html += '</div></div>';
    }
    if (modelVals.length === 2) {
      html += '<div class="au-row au-model"><div class="au-label">' + esc(D.options[mIdx]).replace(/\s+$/, '') + '</div><div class="au-chips au-model-chips" data-opt="' + mIdx + '">';
      modelVals.forEach(function (m) { html += '<button type="button" class="au-chip' + (m.avail ? '' : ' is-out') + '" data-v="' + esc(m.v) + '" aria-pressed="false">' + esc(m.v) + '</button>'; });
      html += '</div></div>';
    }
    if (modelVals.length > 2) {
      html += '<div class="au-row au-model"><label class="au-label" for="au-model-sel">' + esc(D.options[mIdx]).replace(/\s+$/, '') + '</label><select id="au-model-sel" class="au-select" data-opt="' + mIdx + '">';
      modelVals.forEach(function (m) { html += '<option value="' + esc(m.v) + '"' + (m.avail ? '' : ' disabled') + '>' + esc(m.v) + '</option>'; });
      html += '</select></div>';
    }
    otherIdx.forEach(function (oi) {
      var ov = values(oi);
      if (ov.length < 2) return;
      if (ov.length > 2) {
        html += '<div class="au-row"><label class="au-label" for="au-sel-' + oi + '">' + esc(D.options[oi]).replace(/\s+$/, '') + ': <b class="au-oname" data-oi="' + oi + '"></b></label><select id="au-sel-' + oi + '" class="au-select" data-opt="' + oi + '">';
        ov.forEach(function (o) { html += '<option value="' + esc(o.v) + '"' + (o.avail ? '' : ' disabled') + '>' + esc(o.v) + '</option>'; });
        html += '</select></div>';
        return;
      }
      html += '<div class="au-row"><div class="au-label">' + esc(D.options[oi]).replace(/\s+$/, '') + ': <b class="au-oname" data-oi="' + oi + '"></b></div><div class="au-chips" data-opt="' + oi + '">';
      ov.forEach(function (o) { html += '<button type="button" class="au-chip' + (o.avail ? '' : ' is-out') + '" data-v="' + esc(o.v) + '" aria-pressed="false">' + esc(o.v) + '</button>'; });
      html += '</div></div>';
    });
    optsEl.innerHTML = html;

    var fitHero = root.querySelector('.au-fit-hero');
    /* second fit chip inside the sheet for wide screens */
    var fitRow = document.createElement('button');
    fitRow.type = 'button';
    fitRow.className = 'au-fit au-fit-row';
    fitRow.setAttribute('data-act', 'model');
    fitRow.innerHTML = '<span class="au-fit-i">' + ic('check') + '</span><span class="au-fit-t"></span><span class="au-fit-c">Change</span>';
    var priceEl = root.querySelector('.au-price');
    priceEl.parentNode.insertBefore(fitRow, priceEl.nextSibling);

    /* ---------- driving the real controls ---------- */
    function group(idx) { return vs ? vs.querySelector('.pvOpt' + idx) : null; }
    function setOpt(idx, val) {
      var g = group(idx);
      if (!g) return;
      var sel = g.querySelector('select');
      if (sel) {
        for (var k = 0; k < sel.options.length; k++) {
          if (sel.options[k].value === val || sel.options[k].text.trim() === val) { sel.selectedIndex = k; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
        }
        return;
      }
      var inputs = g.querySelectorAll('input[type="radio"]');
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].value === val) {
          var lb = g.querySelector('label[for="' + inputs[j].id + '"]');
          if (lb) lb.click(); else { inputs[j].checked = true; inputs[j].dispatchEvent(new Event('change', { bubbles: true })); }
          return;
        }
      }
    }
    function toast(txt) { /* tiny confirmation on the add button */
      var b = root.querySelector('.au-add');
      if (!b) return;
      b.textContent = txt;
      setTimeout(paintCta, 1600);
    }
    function submit() { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }

    /* ---------- painting ---------- */
    var lastImg = null, lastVid = null;
    function paintCta() {
      var v = curV();
      var add = root.querySelector('.au-add'), buy = root.querySelector('.au-buy');
      if (add) add.textContent = v.a ? 'Add to cart · ' + money(v.p) : 'Sold out';
      if (buy) buy.textContent = 'Buy now';
      if (add) add.disabled = !v.a;
      if (buy) buy.disabled = !v.a;
    }
    function paint() {
      var v = curV();
      var nowEl = root.querySelector('.au-now'), nowTxt = money(v.p);
      if (nowEl.textContent && nowEl.textContent !== nowTxt) { nowEl.classList.remove('is-tick'); void nowEl.offsetWidth; nowEl.classList.add('is-tick'); }
      nowEl.textContent = nowTxt;
      var was = root.querySelector('.au-was'), save = root.querySelector('.au-save');
      if (v.c > v.p) { was.textContent = money(v.c); was.hidden = false; save.textContent = 'Save ' + Math.round((v.c - v.p) / v.c * 100) + '%'; save.hidden = false; }
      else { was.hidden = true; save.hidden = true; }
      if (cIdx > -1) {
        var cn = root.querySelector('.au-cname'); if (cn) cn.textContent = v.o[cIdx];
        [].forEach.call(root.querySelectorAll('.au-colours .au-sw'), function (b) {
          var on = b.getAttribute('data-v') === v.o[cIdx];
          b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on && b.classList.contains('is-x')) root.querySelector('.au-pills').classList.add('is-open');
        });
      }
      if (mIdx > -1) {
        var sel = root.querySelector('.au-select[data-opt="' + mIdx + '"]'); if (sel && sel.value !== v.o[mIdx]) sel.value = v.o[mIdx];
        [].forEach.call(root.querySelectorAll('.au-model-chips .au-chip'), function (b) { var on = b.getAttribute('data-v') === v.o[mIdx]; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        var t = String(v.o[mIdx]).replace(/airpods/i, 'AirPods');
        [].forEach.call(root.querySelectorAll('.au-fit-t'), function (el) { el.textContent = /iphone|airpod/i.test(t) ? 'Fits ' + t : 'For ' + t; });
        [].forEach.call(root.querySelectorAll('.au-fit'), function (el) { el.hidden = false; });
      } else { [].forEach.call(root.querySelectorAll('.au-fit'), function (el) { el.hidden = true; }); }
      otherIdx.forEach(function (oi) {
        var nm = root.querySelector('.au-oname[data-oi="' + oi + '"]'); if (nm) nm.textContent = v.o[oi];
        var osel = root.querySelector('.au-select[data-opt="' + oi + '"]'); if (osel && osel.value !== v.o[oi]) osel.value = v.o[oi];
        [].forEach.call(root.querySelectorAll('.au-chips[data-opt="' + oi + '"] .au-chip'), function (b) { var on = b.getAttribute('data-v') === v.o[oi]; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      });
      var bm = root.querySelector('.au-bm'), bc = root.querySelector('.au-bc'), bh = root.querySelector('.au-b-fit .au-b-h'), bch = root.querySelector('.au-b-fit .au-b-chip:not(.is-btn)');
      var mname = mIdx > -1 ? String(v.o[mIdx]).replace(/airpods/i, 'AirPods') : '';
      if (bm) bm.textContent = mname || 'phone';
      if (bc) bc.textContent = cIdx > -1 ? v.o[cIdx] : 'your choice';
      if (bh) bh.textContent = mname ? 'Made for your ' + mname : 'Made to fit';
      if (bch) bch.textContent = mname || 'Your phone';
      paintCta();
      if (v.id !== lastVid) {
        lastVid = v.id;
        var ki = v.i ? ensureImg(v.i) : null;
        if (ki != null && ki !== lastImg) {
          lastImg = ki;
          var tgt = track.querySelectorAll('.au-img')[ki]; if (tgt && tgt.loading === 'lazy') tgt.loading = 'eager';
          goTo(ki, true);
        }
      }
      var cart = document.querySelector('.header-cart');
      var n = cart ? (cart.textContent.match(/\d+/) || [''])[0] : '';
      var bd = root.querySelector('.au-badge'); if (bd) { bd.hidden = !(n && +n > 0); bd.textContent = n; }
    }

    /* ---------- gallery ---------- */
    var cur = 0;
    /* a variant photo that was not in the first set is added the first time it is needed, and loaded at once */
    function ensureImg(id) {
      if (byImg[id] != null) return byImg[id];
      var m = moreById[id];
      if (!m) return null;
      var im = { s: m.s, t: String(m.s).replace('width=1000', 'width=160'), a: m.a, id: m.id };
      D.images.push(im);
      var k = D.images.length - 1;
      byImg[id] = k;
      var holder = document.createElement('div');
      holder.innerHTML = '<img class="au-img" src="' + esc(im.s) + '" alt="' + esc(im.a) + '" style="background:url(' + esc(im.t) + ') center/cover" width="1000" height="1000" loading="eager" decoding="async">';
      track.appendChild(holder.firstChild);
      var th = root.querySelector('.au-thumbs');
      if (th) { holder.innerHTML = '<button type="button" class="au-th" data-go="' + k + '" aria-label="Photo ' + (k + 1) + '"><img src="' + esc(im.t) + '" alt="" width="72" height="72" loading="lazy" decoding="async"></button>'; th.appendChild(holder.firstChild); }
      var cnt = root.querySelector('.au-count'); if (cnt && cnt.lastChild) cnt.lastChild.nodeValue = ' / ' + D.images.length;
      return k;
    }
    function goTo(k, instant) {
      k = Math.max(0, Math.min(D.images.length - 1, k));
      if (!instant) wake();
      else { var gi = track.querySelectorAll('.au-img')[k]; if (gi && gi.getAttribute('data-hs') && !gi.getAttribute('src')) { gi.setAttribute('srcset', gi.getAttribute('data-hss')); gi.setAttribute('src', gi.getAttribute('data-hs')); } }
      track.scrollTo({ left: k * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      mark(k);
    }
    function mark(k) {
      cur = k;
      [].forEach.call(root.querySelectorAll('.au-dot'), function (d, j) { d.classList.toggle('is-on', j === k); });
      [].forEach.call(root.querySelectorAll('.au-th'), function (d, j) { d.classList.toggle('is-on', j === k); });
      var c = root.querySelector('.au-count span'); if (c) c.textContent = k + 1;
    }
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { var w = track.clientWidth || 1; mark(Math.round(track.scrollLeft / w)); }, 60);
    }, { passive: true });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { goTo(cur + 1); e.preventDefault(); } else if (e.key === 'ArrowLeft') { goTo(cur - 1); e.preventDefault(); } });

    /* ---------- clicks ---------- */
    function choose(idx, val) {
      var nv = pickVariant(idx, val);
      if (nv) { pending = nv; pendAt = Date.now(); idInput.value = nv.id; paint(); }
      setOpt(idx, val);
    }
    root.addEventListener('click', function (e) {
      var t = e.target;
      var th = t.closest && t.closest('[data-go]'); if (th) { goTo(+th.getAttribute('data-go')); return; }
      var sw = t.closest && t.closest('.au-sw'); if (sw) { choose(+sw.parentNode.getAttribute('data-opt'), sw.getAttribute('data-v')); return; }
      var ch = t.closest && t.closest('.au-chip'); if (ch) { choose(+ch.parentNode.getAttribute('data-opt'), ch.getAttribute('data-v')); return; }
      var a = t.closest && t.closest('[data-act]'); if (!a) return;
      var act = a.getAttribute('data-act');
      if (act === 'prev') goTo(cur - 1);
      else if (act === 'next') goTo(cur + 1);
      else if (act === 'more') { var p = root.querySelector('.au-pills'); p.classList.toggle('is-open'); a.textContent = p.classList.contains('is-open') ? 'Less' : '+' + (colourVals.length - 5); }
      else if (act === 'menu') { e.stopPropagation(); var m = document.querySelector('.js-mobile-nav-toggle'); if (m) m.click(); }
      else if (act === 'cart') { e.stopPropagation(); var c = document.querySelector('.header-cart'); if (c) c.click(); }
      else if (act === 'share') {
        var data = { title: D.title, url: location.href.split('?')[0] };
        if (navigator.share) { navigator.share(data).catch(function () { }); }
        else if (navigator.clipboard) { navigator.clipboard.writeText(data.url).then(function () { a.classList.add('is-done'); setTimeout(function () { a.classList.remove('is-done'); }, 1400); }); }
      }
      else if (act === 'model') {
        var s = root.querySelector('.au-select[data-opt="' + mIdx + '"]') || root.querySelector('.au-model-chips .au-chip');
        if (s) { s.scrollIntoView({ block: 'center', behavior: 'smooth' }); setTimeout(function () { try { s.focus(); if (s.showPicker) s.showPicker(); } catch (x) { s.focus(); } }, 350); }
      }
      else if (act === 'add') { submit(); toast('Added'); }
      else if (act === 'buy') { if (window.pmSet && window.pmSet.buyNow) window.pmSet.buyNow(); else submit(); }
      else if (act === 'reviews') {
        var tabs = document.querySelectorAll('.product-tabs a.tablink'), rv = null;
        [].forEach.call(tabs, function (x) { if (/review/i.test(x.textContent)) rv = x; });
        if (rv) { rv.click(); rv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
      else if (act === 'set') { if (window.pmSet && window.pmSet.open) window.pmSet.open(); else { var tz = document.querySelector('.pms-teaser'); if (tz) tz.click(); } }
    });
    root.addEventListener('change', function (e) {
      var s = e.target;
      if (s && s.classList && s.classList.contains('au-select')) setOpt(+s.getAttribute('data-opt'), s.value);
    });

    /* ---------- the set card mirrors the set sheet's teaser ---------- */
    var setCard = root.querySelector('.au-set');
    /* keep the room for the set card while the set sheet is still working it out, so nothing below jumps when it arrives */
    var waitSet = !!document.querySelector('pm-set'), waitT;
    function endWait() { clearTimeout(waitT); root.classList.remove('au-setwait'); }
    if (waitSet) { root.classList.add('au-setwait'); waitT = setTimeout(endWait, 3500); }
    function mirrorSet() {
      var t = document.querySelector('.pms-teaser');
      if (!t) { setCard.hidden = true; return; }
      var thumbs = t.querySelectorAll('.pms-thumbs i'), tt = t.querySelector('.pms-tt b'), sm = t.querySelector('.pms-tt small'), go = t.querySelector('.pms-go');
      var th = '';
      [].forEach.call(thumbs, function (i) { th += '<span class="au-set-th" style="background-image:' + esc(i.style.backgroundImage || 'none') + '"></span>'; });
      setCard.innerHTML = '<span class="au-set-ths">' + th + '</span><span class="au-set-t"><b>' + esc(tt ? tt.textContent : 'Make it a set') + '</b><small>' + esc(sm ? sm.textContent : '') + '</small></span><span class="au-set-p">' + esc(go ? go.textContent.replace(/[›>]/g, '').trim() : '') + '</span>';
      setCard.hidden = false; endWait();
      var bs = root.querySelector('.au-b-set');
      if (bs) {
        bs.hidden = false;
        bs.querySelector('.au-b-ths').innerHTML = th.replace(/au-set-th/g, 'au-b-th');
        bs.querySelector('.au-b-t').textContent = (tt ? tt.textContent : 'Complete set') + (sm ? ' \u00b7 ' + sm.textContent : '');
        bs.querySelector('.au-b-p').textContent = go ? go.textContent.replace(/[\u203a>]/g, '').trim() : '';
      }
    }
    var mt;
    if (window.MutationObserver) {
      new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(mirrorSet, 120); }).observe(host, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'hidden'] });
    }
    mirrorSet();

    /* the AirPods / wallet pair card lives here too */
    var pair = document.querySelector('pm-pair');
    if (pair) root.querySelector('.au-slot-pair').appendChild(pair);

    /* keep in step with the real controls */
    var lastSeen = idInput.value;
    form.addEventListener('change', function () { setTimeout(paint, 60); });
    if (window.MutationObserver) new MutationObserver(paint).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    setInterval(function () { if (idInput.value !== lastSeen) { lastSeen = idInput.value; paint(); } }, 400);
    paint();
    var hc = document.querySelector('.header-cart');
    if (hc && window.MutationObserver) new MutationObserver(paint).observe(hc, { childList: true, subtree: true, characterData: true });
  }
})();
